import * as net from 'util/Net';

export interface AgentFoundryCanvasPreviewResponse {
  signedUrl: string;
  // ISO 8601 timestamp string (`datetime.isoformat()` on the backend).
  expiresAt: string;
}

export function getAgentFoundryCanvasPreviewUrl(
  agentFoundryId: string,
  filePath: string = 'index.html'
): Promise<AgentFoundryCanvasPreviewResponse> {
  return net.postJSONPromise({
    url: `/1/api/llm/agent-foundries/${agentFoundryId}:render-overview-canvas`,
    data: {filePath},
  });
}
